import { defineComponent as x, ref as s, useSlots as E, computed as V, reactive as B, watch as S, provide as j, resolveDirective as N, openBlock as r, createElementBlock as f, Fragment as v, createElementVNode as m, renderSlot as w, renderList as A, withDirectives as L, createBlock as O, normalizeStyle as z, unref as _, createTextVNode as C, toDisplayString as I } from "vue";
import F from "./IstTab.vue.mjs";
const W = { class: "ist-tab" }, G = /* @__PURE__ */ x({
  __name: "IstTabs",
  props: {
    tabs: { default: () => [] },
    modelValue: {},
    loading: { type: Boolean, default: !1 }
  },
  emits: ["tabchange", "update:modelValue"],
  setup(h, { emit: y }) {
    const o = h, i = y;
    let n = s(0), c = s(0);
    const k = s();
    function D(e, t) {
      n.value = e, c.value = t;
    }
    const u = E(), b = u.default ? u.default() : null, T = V(() => {
      const e = b ? b.reduce((t, a) => {
        var l;
        return a.type.__name !== "IstTab" || (l = a.props) != null && l.id && a.props.label && (t[a.props.id] = {
          id: a.props.id,
          label: a.props.label,
          isActive: !0,
          disabled: a.props.disabled
        }), t;
      }, {}) : {};
      for (const t of o.tabs)
        e[t.id] = {
          id: t.id,
          label: t.title,
          isActive: !0,
          disabled: !1
        };
      return e.selectedEvent = {
        id: o.modelValue && o.modelValue != "" ? o.modelValue : e[Object.keys(e)[0]].id
      }, e;
    }), d = B(T.value);
    S(
      () => d.selectedEvent,
      (e) => {
        D(e.width, e.left), d.selectedEvent.id != o.modelValue && (i("tabchange", e.id), i("update:modelValue", e.id)), p.value = Object.keys(d).findIndex((t) => t === e.id);
      },
      { deep: !0 }
    );
    const p = s(0);
    return j("tabsData", d), (e, t) => {
      const a = N("wave");
      return r(), f(v, null, [
        m("div", W, [
          w(e.$slots, "default", {}, void 0, !0),
          (r(!0), f(v, null, A(e.tabs, (l, g) => L((r(), O(F, {
            id: l.id,
            key: g,
            label: l.title,
            "icon-name": l.iconName
          }, null, 8, ["id", "label", "icon-name"])), [
            [a]
          ])), 128)),
          m("div", {
            ref_key: "tabIndicator",
            ref: k,
            class: "ist-tab_indicator",
            style: z({
              width: _(n) + "px",
              left: _(c) + "px"
            })
          }, null, 4)
        ]),
        C(" " + I(d) + " " + I(p.value), 1)
      ], 64);
    };
  }
});
export {
  G as default
};
